<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="30%"
      title="产品型号"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="courseForm">
        <el-form-item label="名称" prop="name" required>
          <el-input v-model="form.name" placeholder="产品型号名称"></el-input>
        </el-form-item>
         <el-form-item label="型号" prop="model_no" required>
          <el-input v-model="form.model_no" placeholder="型号"></el-input>
        </el-form-item>
         <el-form-item label="设备类型" prop="type" required>
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in deviceCode"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" prop="brand_id" required>
          <el-select v-model="form.brand_id" placeholder="请选择">
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
  import { deviceCode } from "../dict";
import { rules } from "./rule";
import { ObjectChangedValue } from "@/js/utils";
export default {
  data() {
    return {
      deviceCode,
      form: {},
      temp: {},
      rules: rules,
      brandList:[],
      addServiceDialog: false
    };
  },

  mounted() {
    this.getBrand()
  },

  methods: {

    getBrand() {
      this.$axios({
        url: "/device/deviceBrand/queryListPage",
        params:{pageSize: 50},
      }).then((res) => {
        this.brandList = res.data.data;
      });
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = Object.assign({}, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.courseForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/device/deviceModel/insert";

      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      let url = "/device/deviceModel/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>